import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  hideLoadingScreen,
  showLoadingScreen,
} from "../../store/slices/loading";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  InputLabel,
  List,
  ListItem,
  MenuItem,
  Paper,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import {
  getCities,
  getDeptos,
  getJobs,
  getPersonas,
  getTotalCenso,
} from "../../services/apiRequests";
import { setJobsList } from "../../store/slices/jobsList";
import { setPersonasList } from "../../store/slices/personas";
import { setDeptosList } from "../../store/slices/deptos";
import CensadosTotales from "./CensadosTotales";
import Deadline from "./Deadline";
import TotalComparison from "./TotalComparison";
import PersonModal from "./PersonModal";
import Refresher from "./Refresher";
import JobChart from "../Charts/JobChart";

const cellDataStyle = "rgba(104, 188, 188, 0.2)";

const Dashboard = ({ userApiKey, needRefreshData, setNeedRefreshData }) => {
  //   const [myNumb, setNumb] = React.useState(0);
  const [selectedJob, setSelectedJob] = React.useState("");
  // const [currentPersonsList, setCurrentPersonsList] =
  //   React.useState(personasArray);
  const [personDetails, setPersonDetails] = React.useState(null);
  const [personModalOpen, setPersonModalOpen] = React.useState(false);
  const [censoPercent, setCensoPercent] = React.useState(-1);
  const [citiesList, setCitiesList] = React.useState([]);
  const [citiesListReady, setCitiesListReady] = React.useState(0);

  const navigateTo = useNavigate();
  const dispatch = useDispatch();

  const userData = useSelector((state) => state.userData.data);
  const jobsList = useSelector((state) => state.jobsList.data);
  const deptosList = useSelector((state) => state.deptosList.data);
  const personasList = useSelector((state) => state.personasList.data);

  const handleJobChange = (event) => {
    setSelectedJob(event.target.value);
  };
  const handlePersonDetail = (person) => {
    let formattedPerson;

    const ocupacionName = jobsList.find((job) => {
      return job.id === person.ocupacion;
    }).ocupacion;
    const deptoName = deptosList.find((depto) => {
      return depto.id === person.departamento;
    }).nombre;
    const cityName = citiesList.find((city) => {
      return city.id === person.ciudad;
    }).nombre;
    formattedPerson = {
      ...person,
      ocupacion: ocupacionName,
      departamento: deptoName,
      ciudad: cityName,
    };

    setPersonDetails(formattedPerson);
  };

  const renderListItem = (person) => {
    return (
      <div key={person.id / 100}>
        <ListItem key={person.id}>
          <Stack
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            sx={{ width: "100%" }}
          >
            <Stack sx={{ minWidth: "40%" }}>
              <Typography variant="h5" component="span">
                {person.nombre}
              </Typography>
              <Typography
                variant="h6"
                component="span"
                sx={{ color: "rgba(200, 200, 200, 0.6)" }}
              >
                #{person.id}
              </Typography>
            </Stack>
            <Stack flexGrow={2}>
              <Typography textAlign={"center"} variant="h6" component="span">
                {
                  deptosList.find((item) => item?.id === person.departamento)
                    ?.nombre
                }
              </Typography>
            </Stack>
            <Stack sx={{ width: "100px" }}>
              <Button
                variant="outlined"
                onClick={() => {
                  handlePersonDetail(person);
                }}
              >
                Detalles
              </Button>
            </Stack>
          </Stack>
        </ListItem>
        <Divider component="li" />
      </div>
    );
  };
  const getPersonasList = () => {
    getPersonas(userApiKey, userData.id).then((data) => {
      if (data.length > 0) {
        dispatch(setPersonasList([...data]));
      } else {
        dispatch(setPersonasList([]));
      }
      dispatch(hideLoadingScreen());
    });
  };

  const getCensoTotal = () => {
    getTotalCenso(userApiKey, userData.id).then((data) => {
      setCensoPercent(data);
    });
  };

  React.useEffect(() => {
    if (personDetails !== null) {
      setPersonModalOpen(true);
    }
  }, [personDetails]);
  React.useEffect(() => {
    getPersonasList();
    getCensoTotal();
  }, [needRefreshData]);
  React.useEffect(() => {
    dispatch(showLoadingScreen());
    const getJobList = () => {
      getJobs(userApiKey, userData.id).then((data) => {
        dispatch(setJobsList(data));
      });
    };
    const getDeptosList = () => {
      getDeptos(userApiKey, userData.id).then((data) => {
        dispatch(setDeptosList(data));
        let newCitiesArray = [];
        if (citiesListReady !== 100) {
          const recursiveCallCities = (dptos, userApiKey, userDataId, indx) => {
            return getCities(userApiKey, userDataId, dptos[indx].id).then(
              (dataCity) => {
                newCitiesArray = [...newCitiesArray, ...dataCity];
                if (dptos[dptos.length - 1].id === dptos[indx].id) {
                  setCitiesList(newCitiesArray);
                  setCitiesListReady(100);
                } else {
                  setCitiesListReady((100 / dptos.length) * indx + 1);
                  dataCity.concat(
                    recursiveCallCities(dptos, userApiKey, userDataId, indx + 1)
                  );
                }
              }
            );
          };
          recursiveCallCities(data, userApiKey, userData.id, 0).then();
        }
      });
    };
    if (!userApiKey && userData === null) {
      navigateTo("/access");
    } else {
      setTimeout(() => {
        dispatch(hideLoadingScreen());
      }, 900);
      getJobList();
      getDeptosList();
      getPersonasList();
      getCensoTotal();
    }
  }, []);
  return (
    <>
      <Stack
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="center"
        flexWrap="wrap-reverse"
        sx={{
          // backgroundColor: "rgba(250, 250,250, 0.2)",
          //   height: {sx: "auto", md: ""}
          minHeight: { md: "93vh" },
        }}
      >
        <Stack
          flexDirection="row"
          justifyContent="space-evenly"
          alignItems="center"
          flexWrap="wrap"
          sx={{
            width: { xs: "100%", md: "90%" },
            minWidth: { md: "1000px" },
            // backgroundColor: "rgba(250, 0, 0, 0.9)",
            // backgroundColor: "rgba(100, 100, 250, 0.2)",
          }}
        >
          <Paper
            elevation={2}
            sx={{
              m: "10px",
              width: { xs: "100%", md: "auto" },
              height: { xs: "auto", md: "300px" },
              minWidth: 128,
              minHeight: 128,
              flexGrow: 1,
              backgroundColor: cellDataStyle,
              marginRight: { md: "0px" },
              marginBottom: { xs: "0px", md: "10px" },
            }}
          >
            <CensadosTotales listaCensados={personasList} />
          </Paper>
          <Paper
            elevation={2}
            sx={{
              m: "10px",
              width: { xs: "100%", md: "auto" },
              height: { xs: "auto", md: "300px" },
              minWidth: 128,
              minHeight: 128,
              flexGrow: 1,
              backgroundColor: cellDataStyle,
              marginRight: { md: "0px" },
              marginBottom: { xs: "0px", md: "10px" },
            }}
          >
            <TotalComparison
              censoTotal={censoPercent}
              userCenso={personasList.length}
            ></TotalComparison>
          </Paper>
          <Paper
            elevation={2}
            sx={{
              m: "10px",
              width: { xs: "100%", md: "auto" },
              minWidth: 128,
              minHeight: 128,
              flexGrow: 1,
              backgroundColor: cellDataStyle,
              height: { xs: "auto", md: "300px" },
            }}
          >
            <Deadline />
          </Paper>
        </Stack>
        <Stack
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent="flex-start"
          alignItems="center"
          flexWrap="wrap"
          sx={{
            width: { xs: "100%", md: "90%" },
            minWidth: { md: "1000px" },
            marginRight: { md: "0px" },
          }}
        >
          <Stack
            flexDirection="column"
            justifyContent="space-evenly"
            alignItems="center"
            flexWrap="wrap"
            sx={{
              flexGrow: 1,
              width: { xs: "100%", md: "auto" },
              height: { xs: "auto", md: "100%" },
              minWidth: { md: "800px" },
              minHeight: { xs: "350px", md: "500px" },
              maxHeight: { xs: "350px", md: "510px" },
              my: { xs: "5px" },
            }}
          >
            <Paper
              elevation={2}
              sx={{
                m: "10px",
                height: { xs: "auto", md: "100%" },
                maxHeight: { xs: "350px", md: "510px" },
                minHeight: { xs: "350px", md: "500px" },
                width: { xs: "calc(100% - 20px)", md: "calc(100% - 10px)" },
                //   minWidth: { xs: "auto", md: "100%" },
                backgroundColor: cellDataStyle,
                flexGrow: 1,
                marginTop: 0,
                marginRight: { md: "0px" },
              }}
            >
              <FormControl fullWidth>
                <InputLabel id="ocupacionLabel">Ocupación</InputLabel>
                <Select
                  labelId="ocupacionLabel"
                  id="ocupacionInput"
                  value={selectedJob}
                  label="Ocupación"
                  onChange={handleJobChange}
                >
                  <MenuItem key={0} value={""}>
                    <i>Ocupacion</i>
                  </MenuItem>
                  {jobsList.map((jobItem) => {
                    return (
                      <MenuItem key={jobItem.id} value={jobItem.id}>
                        {jobItem.ocupacion}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <List
                sx={{
                  padding: 0,
                  overflowY: "scroll",
                  maxHeight: { xs: "290px", md: "445px" },
                  minHeight: { xs: "250px", md: "435px" },
                }}
              >
                {citiesListReady !== 100 && (
                  <>
                    <Box
                      sx={{
                        position: "absolute",
                        display: "inline-flex",
                        transform: "scale(1.5)",
                        top: "50%",
                        left: "47%",
                      }}
                    >
                      <CircularProgress
                        variant="determinate"
                        value={citiesListReady}
                      />
                      <Box
                        sx={{
                          top: 0,
                          left: 0,
                          bottom: 0,
                          right: 0,
                          position: "absolute",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          variant="caption"
                          component="div"
                          color="text.secondary"
                        >
                          {`${Math.round(citiesListReady)}%`}
                        </Typography>
                      </Box>
                    </Box>
                  </>
                )}
                {citiesListReady === 100 &&
                  (personasList.length === 0 ? (
                    <i>No hay ningun registro</i>
                  ) : selectedJob !== "" ? (
                    personasList
                      .filter((person) => person.ocupacion === selectedJob)
                      .map((item) => renderListItem(item))
                  ) : (
                    personasList.map((item) => renderListItem(item))
                  ))}
              </List>
            </Paper>
          </Stack>
          <Stack
            flexDirection="column"
            justifyContent="space-evenly"
            alignItems="center"
            flexWrap="wrap"
            sx={{
              flexGrow: 2,
              width: { xs: "100%", md: "auto" },
              height: { xs: "auto", md: "100%" },
              // backgroundColor: "rgba( 0, 250, 0, 0.3)",
              // backgroundColor: "rgba(250, 00, 0, 0.2)",
              minHeight: "300px",
              maxHeight: "510px",
            }}
          >
            <Paper
              elevation={2}
              sx={{
                m: "10px",
                width: "calc(100% - 20px)",
                minWidth: 128,
                minHeight: "500px",
                flexGrow: 1,
                backgroundColor: cellDataStyle,
                marginTop: 0,
              }}
            >
              {(personasList.length === 0) ? (
                    <i>No hay ningun registro</i>
                  ) : (jobsList.length > 0 ? (
                <JobChart
                  personasList={personasList}
                  jobsList={jobsList}
                ></JobChart>
              ) : (
                <Stack
                  flexDirection={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  sx={{
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <CircularProgress />
                  <Typography> Trayendo datos...</Typography>
                </Stack>
              ))}
            </Paper>
          </Stack>
        </Stack>
      </Stack>
      <Refresher setNeedRefreshData={setNeedRefreshData} />
      <PersonModal
        isOpen={personModalOpen}
        setOpen={setPersonModalOpen}
        personData={personDetails}
        userApiKey={userApiKey}
        userData={userData}
        setNeedRefreshData={setNeedRefreshData}
      ></PersonModal>
    </>
  );
};

export default Dashboard;
